import React from 'react';
import { useNavigate } from 'react-router-dom';

const LegalPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F1F5F9', fontFamily: "'Zen Kaku Gothic New', sans-serif" }}>
      {/* ヘッダー */}
      <header
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.92)', backdropFilter: 'blur(14px)',
          borderBottom: '1px solid rgba(37, 99, 235, 0.1)',
          padding: '1rem 2rem',
        }}
      >
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div
            onClick={() => navigate('/')}
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}
          >
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: '#64748B', letterSpacing: '0.06em' }}>
              勤怠管理
            </span>
            <span
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 800,
                fontSize: '1.45rem',
                color: '#2563EB',
                letterSpacing: '-0.03em',
              }}
            >
              キン<b style={{ color: '#1A2E4A', fontWeight: 800 }}>ログ</b>
            </span>
          </div>
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '9px 22px',
              backgroundColor: 'transparent',
              border: '2px solid #2563EB',
              borderRadius: '50px',
              color: '#2563EB',
              cursor: 'pointer',
              fontSize: '0.88rem',
              fontWeight: 600,
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#2563EB';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#2563EB';
            }}
          >
            トップページに戻る
          </button>
        </div>
      </header>

      {/* コンテンツ */}
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '3rem 2rem' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '2rem', color: '#1E293B' }}>
          特定商取引法に基づく表記
        </h1>

        <div style={{ backgroundColor: '#fff', padding: '2rem', borderRadius: '22px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)', lineHeight: 1.8 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    width: '30%',
                    verticalAlign: 'top',
                  }}
                >
                  販売業者
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>株式会社立山システム</td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    width: '30%',
                    verticalAlign: 'top',
                  }}
                >
                  運営統括責任者
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>駒井大樹</td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    width: '30%',
                    verticalAlign: 'top',
                  }}
                >
                  適格請求書発行事業者登録番号
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>T4013301055765</td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  所在地
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>東京都豊島区東池袋二丁目62番8号 BIGオフィスプラザ池袋1206</td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  電話番号
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>
                  お客様からのご請求に応じて遅滞なく開示いたします
                </td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  お問い合わせ先
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>
                  info@kinlog.jp
                </td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  サービス名称
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>勤怠管理 キンログ</td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  サービス内容
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>クラウド型勤怠管理システムの提供</td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  販売価格
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>
                  基本料金: 月額1,000円（税抜）／1,100円（税込）（10人まで）
                  <br />
                  追加料金: 1人につき月額100円（税抜）／110円（税込）
                  <br />
                  ※11人目以降に適用されます
                  <br />
                  ※消費税率10%（軽減税率対象外）
                  <br />
                  ※価格は予告なく変更する場合があります
                </td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  商品代金以外の必要料金
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>
                  インターネット接続料金、通信料金等はお客様のご負担となります。
                </td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  お支払い方法
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>クレジットカード決済（Stripe経由）</td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  お支払い時期
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>
                  無料トライアル期間（14日間）終了後、毎月の請求日に自動課金されます。
                  <br />
                  ※無料トライアル期間中は課金されません
                </td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  サービスの提供時期
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>
                  お申し込み後、即時ご利用いただけます。
                </td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  返品・キャンセルについて
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>
                  本サービスはデジタルコンテンツのため、商品の性質上、返品・返金には応じかねます。
                  <br />
                  ただし、無料トライアル期間中の解約の場合は料金は発生しません。
                  <br />
                  有料プランへ移行後の解約は、当月末日をもって解約となり、既にお支払いいただいた料金の返金は行いません。
                </td>
              </tr>

              <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  解約方法
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>
                  管理画面の「サブスクリプション管理」ページから、いつでも解約手続きが可能です。
                  <br />
                  解約申請後、当月末日をもって解約となります。
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    padding: '1rem 0',
                    fontWeight: 700,
                    color: '#1E293B',
                    verticalAlign: 'top',
                  }}
                >
                  動作環境
                </td>
                <td style={{ padding: '1rem 0', color: '#64748B' }}>
                  推奨ブラウザ:
                  <ul style={{ margin: '0.5rem 0', paddingLeft: '1.5rem' }}>
                    <li>Google Chrome（最新版）</li>
                    <li>Mozilla Firefox（最新版）</li>
                    <li>Microsoft Edge（最新版）</li>
                    <li>Safari（最新版）</li>
                  </ul>
                  ※上記以外のブラウザでは正常に動作しない場合があります
                  <br />
                  ※スマートフォン・タブレットでもご利用いただけますが、PC環境を推奨します
                </td>
              </tr>
            </tbody>
          </table>

          <div
            style={{
              marginTop: '2rem',
              padding: '1rem',
              backgroundColor: '#FEF3C7',
              borderLeft: '4px solid #F59E0B',
              color: '#92400E',
            }}
          >
            <p style={{ margin: 0, fontSize: '0.9rem' }}>
              ※
              本ページの情報は、特定商取引法に基づいて記載しています。ご不明な点がございましたら、上記お問い合わせ先までご連絡ください。
            </p>
          </div>

          <p style={{ textAlign: 'right', color: '#999', marginTop: '3rem' }}>2025年11月1日 制定</p>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
